import React from 'react';
import { BRAND_LOGO_PATH } from '../constants/thirdPartyPages';

// 🔑 THE REAL LOGO ON THE THIRD-PARTY PAGES (Jesse, 2026-10-29) — the image the app header uses, never a text
// "Doorly" wordmark. `band` puts it on its own white strip above a page's blue header bar (the logo is black, so it
// never sits on the blue).
export default function ThirdPartyLogo({ height = 32, band = false }) {
  const img = (
    <img src={`${process.env.PUBLIC_URL || ''}${BRAND_LOGO_PATH}`} alt="Doorly" data-testid="third-party-logo" draggable={false}
      style={{ height: `${height}px`, width: 'auto', display: 'block', margin: '0 auto' }} />
  );
  if (!band) return img;
  return <div style={{ background: '#ffffff', padding: '20px 36px', textAlign: 'center' }}>{img}</div>;
}
